import { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider as MUIThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
//
import palette from './palette';
import typography from './typography';
import componentsOverride from './overrides';
import shadows, { customShadows } from './shadows';
import { useGlobalTheme, THEME_COLORS } from '../contexts/ThemeContext';

// ----------------------------------------------------------------------

// ThemeProvider.propTypes = {
//   children: PropTypes.node,
// };

export default function ThemeProvider({ children }) {
  const { globalTheme } = useGlobalTheme();

  const themeOptions = useMemo(
    () => {
      const customColors = THEME_COLORS[globalTheme] || THEME_COLORS.ocean;

      const dynamicPalette = {
        ...palette,
        mode: globalTheme === 'dark' ? 'dark' : 'light',
        primary: { ...palette.primary, main: customColors.primary },
        background: { ...palette.background, paper: customColors.containerBg, default: customColors.sidebarBg },
        text: { ...palette.text, primary: customColors.text, secondary: customColors.subText }
      };

      return {
        palette: dynamicPalette,
        shape: { borderRadius: 6 },
        typography,
        shadows,
        customShadows
      };
    },
    [globalTheme]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
}
